export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8906.287f633d.jpg";